export default {
  methods: {
    numberWithDelimiter (num) {
      if (num || num === 0) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    }
  }
}
